import { jsxs, jsx } from 'react/jsx-runtime';
import { Flex } from '@fabric-app/ui/components/Flex';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';
import { styled } from 'styled-components';

const HeaderWrapper = styled(Flex).attrs({
  justifyContent: "space-between",
  alignItems: "center"
}).withConfig({
  displayName: "ResourceHeader__HeaderWrapper",
  componentId: "sc-74743f79-0"
})([
  `height:4rem;padding:1rem;padding-left:1.5rem;border-bottom:1px solid `,
  `;`
], cssVar["color-border-primary"]);
const ResourceHeader = () => {
  return /* @__PURE__ */ jsxs(HeaderWrapper, {
    children: [
      /* @__PURE__ */ jsx("div", {
        children: "Unknown file"
      }),
      /* @__PURE__ */ jsx(Flex, {
        gap: 12,
        alignItems: "center",
        children: /* @__PURE__ */ jsx(Modal.Close, {
          variant: "bg-secondary",
          size: "sm"
        })
      })
    ]
  });
};

export { ResourceHeader };
//# sourceMappingURL=ResourceHeader.js.map
